import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { BindReportGrid, ReverseFormatDate, exportToExcel, formatDate, setFocus, setTitle } from "../Common/Common";
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';

const EmptySortingReport = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const WarehouseName = cookies.get('warehouseName');
    const WarehouseCode = cookies.get('warehouseCode')
    const [isUpdate, setIsUpdate] = useState(false)
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [SalesPerson, setSalesPerson] = useState([]);
    const [wareHouseData, setWareHouseData] = useState([]);

    const [ReportTypeDropDown] = useState([
        {
            ReportTypeCode: 'Summarised',
            ReportType: 'Summarised'
        },
        {
            ReportTypeCode: 'DETAIL',
            ReportType: 'DETAIL'
        },
    ]);
    const [MenuText, setMenuText] = useState("Empty Sorting Report");
    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })

    const [FilterData, setFilterData] = useState({
        ReportType: ReportTypeDropDown[0].ReportTypeCode,
        PageIndex: "1",
        InvoiceNo: "",
        Customer: "",
        WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
        SortingDateFrom: "",
        SortingDateTo: "",
        CollectionDateFrom: "",
        CollectionDateTo: "",
        Active: true,
        SummarizedReport: false,
    });
    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }

    useEffect(() => {
        setTitle("EmptySortingReport", setOpen);
        setFocus('txtInvoiceNo');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    //useEffect(() => {
    //    getInvoiceData();
    //}, [FilterData.PageIndex, isUpdate]);


    const getInvoiceData = (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExEmptySortingReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'EmptySortingReport');

                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({

                });
            }
            setIsLoading(false)
        });
    }

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                InvoiceNo: "",
                WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
                SortingDateFrom: "",
                SortingDateTo: "",
                CollectionDateFrom: "",
                CollectionDateTo: "",
            }
        );
        setTableData({});
        setFocus('txtInvoiceNo');
        setIsUpdate(!isUpdate)
    }

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getInvoiceData();
    }

    const handleDownloadExcel = async () => {
        getInvoiceData('E');
    }
    const handleChange1 = (event, value) => {
        getInvoiceData("S", value);
    };

    //const getSalesPerson = () => {
    //    setSalesPerson([]);
    //    let temp = {
    //        Type: "GetSalesPerson",
    //        Prefix: "",
    //        ContextKey: "",
    //        ContextKey2: ""
    //    };
    //    const loginCodeString = String(LoginUserCode);
    //    const data = {
    //        Token,
    //        LoginUserCode: loginCodeString
    //    };

    //    getCommonData({ ...data, ...temp }, (res) => {
    //        if (res && res.status === "SUCCESS") {
    //            let salesPersonData = res.autoCompleteData || [];
    //            setSalesPerson(salesPersonData);
    //        } else {
    //            setSalesPerson([]);
    //        }
    //    });
    //};
    const getWareHouse = () => {
        setWareHouseData([])
        let temp = {
            Type: "GetSalesPersonANDWarehouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let warehouseData = res.autoCompleteData || [];
                setWareHouseData(warehouseData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setWareHouseData([]);
            }
        });
    }

    let WareHouseArr = []
    for (let i = 0; i < wareHouseData.length; i++) {
        let mydata = wareHouseData[i]?.values
        WareHouseArr.push(mydata)
    };

    useEffect(() => {
        if (FilterData.SortingDateFrom) {
            const fromDateObj = new Date(FilterData.SortingDateFrom);
            const toDateObj = new Date(FilterData.SortingDateTo);

            if (
                !FilterData.SortingDateTo ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    SortingDateTo: formattedNextDay
                }));
            }
        }
    }, [FilterData.SortingDateFrom]);

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText ? MenuText : "Empty Sorting Report"}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSortingDateFrom") };
                                                }}
                                                label='WareHouse / Sales Person'
                                                disabled={WarehouseCode ? true : false}
                                                placeholder="WareHouse / Sales Person"
                                                maxLength='50'
                                                options={WareHouseArr}
                                                id='txtWareHouse'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getWareHouse()}
                                                inputValue={FilterData.WareHouse ? FilterData.WareHouse : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('WareHouse', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Sorting Date</label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.SortingDateFrom) || null}
                                                        id='txtSortingDateFrom'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, SortingDateFrom: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtSortingDateTo')
                                                            };
                                                        }}
                                                        maxDate={new Date()}
                                                    /></div>
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.SortingDateTo) || null}
                                                        id='txtSortingDateTo'
                                                        className="form-control"
                                                        placeholderText='To Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, SortingDateTo: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtReportType')
                                                            };
                                                        }}
                                                        minDate={new Date(FilterData.SortingDateFrom) || null}
                                                    /></div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-switch">
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="activeCheckbox"
                                                    >
                                                        Empty Sorting
                                                    </label>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="chkActive"
                                                        name='Active'
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('btnSave')
                                                            };
                                                        }}
                                                        checked={FilterData.Active}
                                                        onChange={(e) => {
                                                            setFilterData({
                                                                ...FilterData, Active: e.target.checked
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-switch">
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="summarizedReportCheckbox"
                                                    >
                                                        Summarized Report
                                                    </label>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="chkSummarizedReport"
                                                        name='SummarizedReport'
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('btnSave')
                                                            };
                                                        }}
                                                        checked={FilterData.SummarizedReport}
                                                        onChange={(e) => {
                                                            setFilterData({
                                                                ...FilterData, SummarizedReport: e.target.checked
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} currentPageNo={currentPageNo}
                handleChange1={handleChange1} PrintColumnName='PrintInvoiceNo' handleClearData={handleClearData} />

            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default EmptySortingReport